<template>
  <b-modal id="delete" title="Client löschen">
    <span
      >Sind sie sicher das sie den client
      <strong>{{ clientName }}</strong> löschen wollen?</span
    >
    <template v-slot:modal-footer="{ ok, cancel }">
      <div>
        <button type="button" class="btn btn-secondary mr-2" @click="cancel()">
          Abbrechen
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="
            deleteClient();
            ok();
          "
        >
          Löschen
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ModalDelete",
  data() {
    return {};
  },
  computed: {
    clientName() {
      return this.$store.state.clientName;
    }
  },
  methods: {
    deleteClient() {
      this.$store.dispatch("deleteClient");
    }
  }
};
</script>
